



































































import NotificationService from '@/libs/core/notifications/notification-service';
import {Component, Vue, Watch} from "vue-property-decorator";
import {DropDownButtonPlugin} from "@syncfusion/ej2-vue-splitbuttons";

import {authStore} from '@/libs/auth/+store/store';
import {tenantsStore, tenantUsersStore} from '@/libs/tenants/+state/store';
import {AuthAction, AuthGetter} from '@/libs/auth/models/auth-state';
import {CrudAction, CrudReponse} from './libs/core/+state/models/crud-action';
import {createCrudQueryPayload} from './libs/core/+state/models/crud-query-payload';
import {
	ApplicationUserModel,
	CatalogueItemModel,
	CodebookModel,
	TenantModel,
	TenantUserModel,
	UnitOfMeasureModel
} from './libs/Api';
import {CrudGetter} from './libs/core/+state/models/crud-getter';
import {EventTypeEnum} from '@/libs/core/models/event-type-enum';

import {formatDate} from '@/libs/common/functions/format-date';
import {applicationUserStore} from './libs/user-settings/+state/store';
import Page from './Page.vue';
import {codebooksStore} from './libs/codebooks/+state/store';
import {unitsOfMeasureStore} from './libs/units-of-measure/+state/store';
import {districtsStore} from './libs/districts/+state/store';
import {townsStore} from './libs/towns/+state/store';

import Sidebar from '@/libs/common/components/Sidebar.vue';
import SearchBox from '@/libs/search/components/SearchBox.vue';

import {GlobalVariables} from '@/libs/core/global';
import {catalogueItemsStore} from './libs/catalogue-items/+state/store';
import { Filters } from './filters';

Vue.use(DropDownButtonPlugin);

@Component({
  components: {
    Sidebar, SearchBox
  },
})
export default class App extends Page {

  loading = true;
  user: any = {};
  selectedTenant: string | null = null;
  locale = "cs";
  tenantMenu = false;
  test = [];
  
  //@Prop() tenantId!: string;

  get tenantId (): string | null {
    return authStore.useGetter(AuthGetter.GetTenant);
  }
  
  get isLoggedIn(): boolean {
    return authStore.useGetter(AuthGetter.GetIsLoggedIn);
  }

  get tenants() : Array<TenantModel> {
    return tenantsStore.useGetter(CrudGetter.Data);
  }

  get tenant(): TenantModel {
    return tenantsStore.useGetter(CrudGetter.Detail);
  }

  get userInfo(): ApplicationUserModel {
    return applicationUserStore.useGetter(CrudGetter.Detail);
  }

  get tenantLoading() {
    return tenantsStore.useGetter(CrudGetter.Pending);
  }

  created () {
    this.$i18n.locale = window.localStorage.language ?? "cs";
    if (!window.localStorage.language) {
      window.localStorage.language = "cs";
    }
    this.locale = this.$i18n.locale;
    this.$vuetify.lang.current = this.locale;
    GlobalVariables.lang = this.locale;
  }

  @Watch("isLoggedIn")
  isLoggedInChanged (v: boolean, p: boolean) {
    if (!v) {
      if (this.$route.name != "PasswordRecovery" && this.$route.name != "SignIn" && this.$route.name != "SignUp" && this.$route.name != "SignUpOrganization")
        this.$router.push({ name: "SignIn" });
    }
    else {
      this.connectSignalR();
      if (v && v != p) {
        this.loadUserData();
      }
    }
  }

  @Watch("tenantId")
  tenantIdChanged (v: string, p: string) {
    this.selectedTenant = v;
    //this.loadTenantStores();
    if (p != null && v != null && v != p) {
      const currentRoute = {...this.$router.currentRoute};
      currentRoute.params.tenantId = v;
      this.$router.replace({
        name: currentRoute.name!,
        params: currentRoute.params!,
        query: currentRoute.query!
      });
      window.location.reload();
    }
  }

  @Watch("selectedTenant")
  selectedTenantChanged (v: string, p: string) {
    if (v != null && v !== p && v != this.$route.params.tenantId) {
      authStore.dispatch(AuthAction.SetTenant, v);
    }
  }

  @Watch("$route")
  routeChanged () {
    this.detectTenantMenu();
    this.detectPermissions();
    this.detectSystemUser();
    const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser);
    if (this.tenantMenu && this.tenantId == null) {
      const tenants = tenantsStore.useGetter(CrudGetter.Data) as TenantModel[];
      if (tenants.length == 0) {
        this.$router.push({ name: "UserSettings" });
      }
      else {
        authStore.dispatch(AuthAction.SetTenant, tenants[0].id!);
      }
    }
  }

  mounted() {
    this.detectTenantMenu();
    const envKey = process.env.NODE_ENV != "production" ? ".".concat(process.env.NODE_ENV!) : "";
    fetch(process.env.BASE_URL + "config".concat(envKey).concat(".json")).then((result) => {
      result.json().then((jsonBody: any) => {
        (window as any).ApiService.baseUrl = jsonBody.ApiEndpoint;
        (window as any).SaasApiEndpoint = jsonBody.SaasApiEndpoint;
        const self = this;
        authStore.dispatch(AuthAction.UserInfo);
        const subscription = this.$store.subscribe((mutation, _state) => {
          if (mutation.type === authStore.getActionName(AuthAction.UserInfo)) {
            subscription();
            self.user = mutation.payload;
            (window as any).user = self.user;
            if (!_state.AUTH.isLoggedIn && self.$route.name !== "PasswordRecovery" && self.$route.name !== "SignIn" && self.$route.name !== "SignUp" && self.$route.name != "PublicOffer") {
              this.loading = false;
              self.$router.push({ name: "SignIn" });
            }
            else if (self.$route.name == "PasswordRecovery" || self.$route.name == "SignIn" || self.$route.name === "SignUp" || self.$route.name == "PublicOffer") {
              this.loading = false;
            }
            else {
              Filters.checkFiltersValidity();
              this.loadUserData();
              this.connectSignalR();
            }
          }
        });
      });
    });
    (window as any).Journaly.subscribe((tenantId: string): Promise<string> => {
      tenantsStore.dispatch(CrudAction.Get, { id: tenantId })
      tenantsStore.dispatch(CrudAction.Get, { id: tenantId, key: tenantId });
      return new Promise((resolve) => resolve("opened"));
    }, EventTypeEnum.TenantChanged);
  }

  toggleClick() {
    (this.$refs.dockSidebar as any).toggle();
  }

  connectSignalR() {
    NotificationService.init();
  }

  signout () {
    authStore.dispatch(AuthAction.SignOut);
    authStore.dispatch(AuthAction.SetTenantUser, null);
    authStore.dispatch(AuthAction.SetTenant, null);
    authStore.dispatch(AuthAction.SetUser, null);
    localStorage.setItem('filters', '');
    localStorage.setItem('filtersValidity', '');
  }

  private detectTenantMenu () {
    this.tenantMenu = this.$router.currentRoute.meta?.tenant != false;
  }

  loadUserData () {
    this.loading = true;
    applicationUserStore.dispatch(CrudAction.Get, {});
    this.subscribe(applicationUserStore, CrudReponse.Get).then((e: any) => {
      tenantsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TenantModel>({
        field: 'name',
        order: 'asc'
      }));
      this.subscribe(tenantsStore, CrudReponse.GetAll).then((e: TenantModel[]) => {
      this.detectSystemUser();
        if (e.length > 0) {
          this.loadCodebooks().then(() => {
            this.loadUnitsOfMeasure().then(() => {
              const tenantId = this.$route.params.tenantId;
              this.selectedTenant = tenantId;
              if (tenantId == undefined && e.length > 0) {
                authStore.dispatch(AuthAction.SetTenant, e[0].id!);
                tenantsStore.dispatch(CrudAction.Get, { id: e[0].id! })
                tenantsStore.dispatch(CrudAction.Get, { id: e[0].id!, key: e[0].id! });
                this.loadTenantStores();
                //this.$router.push({ name: "Dashboard", params: { tenantId: e[0].id! } });
                this.selectedTenant = e[0].id!;
              }
              else {
                authStore.dispatch(AuthAction.SetTenant, tenantId);
                tenantsStore.dispatch(CrudAction.Get, { id: tenantId })
                tenantsStore.dispatch(CrudAction.Get, { id: tenantId, key: tenantId });
                this.loadTenantStores();
                this.selectedTenant = tenantId;
              }
            });
          });
        }
        else {
          this.$router.push({ name: "UserSettings" });
          this.loading = false;
        }
      });
    });
  }

  loadCodebooks () : Promise<any> {
    return new Promise((resolve, reject) => {
      codebooksStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<CodebookModel>());
      this.subscribe(codebooksStore, CrudReponse.GetAll).then((e: CodebookModel[]) => {
        resolve(e);
      }).catch((e: any) => {
        reject(e);
      });
    });
  }

  loadUnitsOfMeasure () : Promise<any> {
    return new Promise((resolve, reject) => {
      unitsOfMeasureStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<UnitOfMeasureModel>());
      this.subscribe(unitsOfMeasureStore, CrudReponse.GetAll).then((e: UnitOfMeasureModel[]) => {
        resolve(e);
      }).catch((e: any) => {
        reject(e);
      });
    });
  }

  loadTenantStores () {
    const tenantId = authStore.useGetter(AuthGetter.GetTenant);
    NotificationService.joinTenant(tenantId);
    this.loadDistricts().then(() => {
      this.loadTowns().then(() => {
        this.loadTenantUsers().then(() => {
          this.loadCatalogueItems().then(() => {
            this.detectPermissions();
            this.loading = false;
          });
        });
      });
    });
  }

  loadDistricts () : Promise<any> {
    return new Promise((resolve, reject) => {
      districtsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<UnitOfMeasureModel>());
      this.subscribe(districtsStore, CrudReponse.GetAll).then((e: UnitOfMeasureModel[]) => {
        resolve(e);
      }).catch((e: any) => {
        reject(e);
      });
    });
  }

  loadTowns () : Promise<any> {
    return new Promise((resolve, reject) => {
      townsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<UnitOfMeasureModel>());
      this.subscribe(townsStore, CrudReponse.GetAll).then((e: UnitOfMeasureModel[]) => {
        resolve(e);
      }).catch((e: any) => {
        reject(e);
      });
    });
  }

  loadCatalogueItems () : Promise<any> {
    return new Promise((resolve, reject) => {
      catalogueItemsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<CatalogueItemModel>());
      this.subscribe(catalogueItemsStore, CrudReponse.GetAll).then((e: CatalogueItemModel[]) => {
        resolve(e);
      }).catch((e: any) => {
        reject(e);
      });
    });
  }

  loadTenantUsers () : Promise<any> {
    return new Promise((resolve, reject) => {
      tenantUsersStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TenantUserModel>());
      this.subscribe(tenantUsersStore, CrudReponse.GetAll).then((e: TenantUserModel[]) => {
        const user = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
        const tenantUser = e.find(x => x.userId == user.id) ?? null;
        authStore.dispatch(AuthAction.SetTenantUser, tenantUser);
        resolve(e);
      }).catch((e: any) => {
        reject(e);
      });
    });
  }

  formatDateTime (dateTime: string) {
    return formatDate(dateTime);
  }

  toUserSettings () {
    let tenantId = "";
    if (this.tenantId)
      tenantId = this.tenantId;
    else
      tenantId = "";

    if (tenantId != "")
      this.$router.push({ name: "UserSettings", params: { tenantId: tenantId } });
    else
      this.$router.push({ name: "UserSettings" });
  }

  detectPermissions () {
    var tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    if (Array.isArray(this.$route.meta?.permissions) && this.$route.meta?.permissions?.length > 0) {
      var requestedPermissions = this.$route.meta!.permissions! as Array<string>;
      if (!requestedPermissions.any(x => x == tenantUser?.accountType)) {
        this.$router.push({ name: "Dashboard", params: { tenantId: this.tenantId! } })
      }
    }
  }

	private detectSystemUser () {
		if (this.$router.currentRoute.meta?.systemUser == true) {
			const applicationUser = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
			if (!applicationUser?.systemUser) {
				this.$router.push({ name: "Home", params: { tenantId: this.tenantId! } });
			}
		}
	}

  getInitials (v: string) {
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

    let initials: any = [...v.matchAll(rgx)] || [];

    initials = (
      (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
    ).toUpperCase();

    return initials;
  }
}
